export const LIST_LAYOUT_PAGE_SIZE = ["20", "40", "60", "80", "100"];
export const LIST_LAYOUT_DEFAULT_PAGE_SIZE = "20";